import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { DATA_VIZ_COLORS } from "../../../config/chartColors";
import type { PerformanceTrend } from "../../../generated/graphql";

interface PerformanceTrendChartProps {
  data: PerformanceTrend[];
}

export function PerformanceTrendChart({ data }: PerformanceTrendChartProps) {
  if (!data || data.length === 0) {
    return (
      <div className="chart-container">
        <div className="chart-empty">No performance trend data available</div>
      </div>
    );
  }

  const chartData = data.map((trend) => ({
    date: new Date(trend.date).toLocaleDateString(),
    retention: (trend.averageRetention * 100).toFixed(1),
    successRate: trend.successRate.toFixed(1),
    reviews: trend.reviewCount,
  }));

  return (
    <div className="chart-container">
      <div className="chart-header">
        <h4 className="h6">Performance Trend</h4>
      </div>
      <div className="chart-body">
        <ResponsiveContainer width="100%" height={400}>
          <LineChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis label={{ value: "Percentage (%)", angle: -90, position: "insideLeft" }} />
            <Tooltip />
            <Legend />
            <Line
              type="monotone"
              dataKey="retention"
              stroke={DATA_VIZ_COLORS.success}
              strokeWidth={2}
              name="Retention %"
            />
            <Line
              type="monotone"
              dataKey="successRate"
              stroke={DATA_VIZ_COLORS.primary}
              strokeWidth={2}
              name="Success Rate %"
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
